export default {
    footer : {
        background: "#403F41",
        padding: "20px",
        color: "#fff",
        '& img':{
            width: '150px',
        }
    },
};